<template>
  <div>
    <el-row class="layout__bottom">
      <el-col :span="8">
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">{{`${isCollapse?'打开':'关闭'}导航`}}</div>
          <i class="iconfont icon-navicon" @click="toggleCollapse"></i>
        </el-tooltip>
      </el-col>
      <el-col :span="16" class="right">
        <template v-if="isClient">
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content" v-show="currentMessage.tooltip">{{currentMessage.tooltip}}</div>
            <span class="layout__bottom__text" :class="{'success':success,'fail':!success}" @click="connectSpecialNetWork"><i
                :class="currentMessage.icon" v-if="currentMessage.icon"></i> {{currentMessage.message}}</span>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content" v-show="currentMessage.tooltip">{{currentMessage.tooltip}}</div>
            <i class="iconfont icon-wifi" @click="connectSpecialNetWork"></i>
          </el-tooltip>
        </template>
        <el-tooltip class="item" content="产品幕后人员" effect="dark" placement="top">
          <i class="iconfont icon-renyuan-kaoqin" @click="staffVisible = true"></i>
        </el-tooltip>
        <el-tooltip class="item" content="保单号批量处理小工具" effect="dark" placement="top">
          <i class="iconfont icon-num" @click="openTool"></i>
        </el-tooltip>
        <el-tooltip class="item" content="刷新当前页" effect="dark" placement="top">
          <i class="iconfont icon-shuaxin" @click="refresh"></i>
        </el-tooltip>
        <template v-if="isClient">
          <el-tooltip class="item" content="关闭VPN" effect="dark" placement="top">
            <i class="iconfont icon-shanchu" @click="closeVPN"></i>
          </el-tooltip>
          <el-tooltip content="清理缓存" effect="dark" placement="top">
            <i class="iconfont icon-shanchu1" @click="clearCache"></i>
          </el-tooltip>
          <el-tooltip class="item" content="打开新页面" effect="dark" placement="top">
            <i class="iconfont icon-fuzhi" @click="openUrl"></i>
          </el-tooltip>
          <el-tooltip class="item" content="修复工具箱" effect="dark" placement="top" v-if="showRepairedTool">
            <i class="iconfont icon-shezhi" @click="openRepairedTool"></i>
          </el-tooltip>
          <el-tooltip class="item" content="打开新用户" effect="dark" placement="top">
            <i class="iconfont icon-yonghuzu" @click="openWindow"></i>
          </el-tooltip>
        </template>
        <el-tooltip class="item" content="锁屏" effect="dark" placement="top">
          <i class="iconfont icon-guanbi1" @click="lockScreen"></i>
        </el-tooltip>
      </el-col>
    </el-row>
    <staffDialog v-model="staffVisible"></staffDialog>
    <ybl-dialog :visible="isShowTool" title="保单号批量处理工具" width="1000px" @close="close" :showFooter="false" top="15vh">
      <div>1、通过此工具，能批量处理多行文本，将本文内容转换为符合系统输入的多行保(批)单号的规格，降低手工操作输错风险；</div>
      <div>2、文本内最大可输入10000文字</div>
      <div class="deal-container">
        <div class="deal-item">
          <el-input type="textarea" :rows="8" placeholder="粘贴待处理的保(批)单号" v-model="unDealText" class="limit-textarea" maxlength="10000" show-word-limit></el-input>
        </div>
        <div class="deal-translate" @click="translateOpt">
          <div>点击转换</div>
          <div><i class="el-icon-d-arrow-right arrow-right"></i></div>
        </div>
        <div class="deal-item">
          <el-tooltip class="item" content="点击复制" effect="dark" placement="top">
            <i class="el-icon-document-copy copy-icon" @click="copyValue"></i>
          </el-tooltip>
          <el-input type="textarea" :rows="8" placeholder="处理后的区域" v-model="dealText" class="limit-textarea"></el-input>
        </div>
      </div>
    </ybl-dialog>
  </div>
</template>

<script>
import { openNavUrl, day, openNewWindow, storage } from '@/utils'
import crypto from '@/utils/crypto'
import request from '@/services/base'
import { mapGetters } from 'vuex'
import copy from 'copy-to-clipboard'
import staffDialog from '@/components/staffDialog/index.vue'
export default {
  name: 'yblBottom',
  components: {
    staffDialog
  },
  data () {
    return {
      isCollapse: false,
      softVersion: {
        /*
          当有新版本的时候请修改以下三个字段，同时要上传软
          件到服务器，还要修改http://pro.ananyun.net的地址指向
        */
        latest: 728, // 软件的最新版本
        last: 'v7.2.8', // 软件的最新版本字符串,updatelog.cshtml也要修改配置
        downUrl: ('http://pro.youbaolian.cn'), // 下载地址,updatelog.cshtml也要修改配置
        useBatch: 380, // 软件的执行批处理的版本
        killProcess: 421 // 软件内支持关闭VPN进程的版本
      },
      currentMessage: {},
      messages: [{message: '网络连接中...', tooltip: ''},
        {message: '您当前是出单系统网', tooltip: '网络检测每30分钟执行一次，如不能连接，可点击重连', icon: 'el-icon-success'},
        {message: '您当前网络不是出单系统网，部分出单系统可能无法访问，点击切换', tooltip: '点击连接出单系统网', icon: 'el-icon-info'}],
      loadedVersion: 0, // 加载后软件版本
      isShowTool: false,
      unDealText: null,
      dealText: null,
      staffVisible: false
    }
  },
  created () {
    this.currentMessage = this.messages[0]
    this.initNetwork()
  },
  mounted () {
    let _this = this
    window.addEventListener('load', function () {
      // _this.onload()
      console.log('🚀 ~ file: Bottom.vue:83 ~ _this:', window.klb_req)
      if (_this.isClient) {
        _this.loadedVersion = window.klb_req.ver.replace(/\./g, '')
      }
    })

    _this.$once('hook:beforeDestroy', () => {
      // window.removeEventListener('load', _this.onload, false)
    })
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER'
    ]),
    currentVersion () {
      return (window.klb_req && window.klb_req.ver) ? Number(window.klb_req.ver.replace(/\./g, '')) : 0
    },
    userInfo () {
      return this.CUSTOMER_LOGINCUSTOMER && this.CUSTOMER_LOGINCUSTOMER.data
    },
    partnerId () {
      return this.userInfo && this.userInfo.PartnerId
    },
    success () {
      return this.currentMessage.icon.indexOf('success') > 0
    },
    isClient () {
      return !!window.IAgencyWebCall
    },
    showRepairedTool () {
      console.log('🚀 ~ file: Bottom.vue:99 ~ showRepairedTool ~ this.currentVersion:', this.currentVersion, window.klb_req)
      return +this.currentVersion >= 777 || +this.loadedVersion >= 777
    }
  },
  methods: {
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
      storage.setItem('collapse', this.isCollapse)
      console.log(this.isCollapse)
      console.log(storage.getItem('collapse'))
      this.$emit('toggle', this.isCollapse)
    },
    refresh () {
      window.location.reload()
    },
    closeVPN () {
      if (this.currentVersion > this.softVersion.useBatch) {
        this.$confirm('软件内执行关闭VPN的操作，将会关闭VPN，关闭VPN后某些保险公司会无法正常访问，您确认要继续执行么？', '', {
          confirmButtonText: '继续'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在关闭VPN进程，请稍等 ...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          if (this.currentVersion > this.softVersion.killProcess) {
            this.killProcess()
          }
          loading.close()
        }).catch(() => { })
      } else {
        this.$alert(`抱歉！您当前版本(v${(window.klb_req && window.klb_req.ver) || 0})不支持在软件内关闭VPN进程，请先升级到v3.8及以上版本，<a href='/Home/UpdateLog' target='_blank'>去升级软件</a>`, '', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '关闭'
        })
      }
    },
    // 杀进程
    killProcess (isVpn = true) {
      if (window.IAgencyWebCall) {
        isVpn && window.IAgencyWebCall('KillProcessByName', 'Proxifier.exe')
        window.IAgencyWebCall('KillProcessByName', 'zhibaokeClient.exe')
        window.IAgencyWebCall('KillProcessByName', 'zhibaokeService.exe')
      }
    },
    clearCache () {
      if (this.currentVersion > this.softVersion.useBatch) {
        this.$confirm('软件内执行清理缓存的操作，将会强制关闭软件，清理结束后会自动激活软件到登录页面，您确认要继续执行么？', '').then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在清理软件缓存，清理成功后会自动激活软件，请稍等 ...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          if (this.currentVersion <= 730) {
            window.IAgencyWebCall && window.IAgencyWebCall('ExeFile', 0, '清理缓存.bat', '', 0)
          } else if (this.currentVersion > 730 && this.currentVersion < 760) {
            window.IAgencyWebCall && window.IAgencyWebCall('ExeFile', 0, 'CacheClear.exe', '', 0)
          } else if (this.currentVersion >= 2000) {
            window.IAgencyWebCall('CacheClear')
          } else {
            window.IAgencyWebCall && window.IAgencyWebCall('ExeFile', 0, '优保联.exe', ' CacheClear ', 1)
          }
          loading.close()
        }).catch(() => { })
      } else {
        this.$alert(`抱歉！您当前版本(v${(window.klb_req && window.klb_req.ver) || 0})不支持在软件内清除缓存，请先升级到v3.8及以上版本，<a href='/Home/UpdateLog' target='_blank'>去升级软件</a>`, '', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '关闭'
        })
      }
    },
    openUrl () {
      let tabId = new Date().getTime().toString()
      openNavUrl('/home', '管理中心', location.host, 'blank', false, 0, tabId)
    },
    openWindow () {
      if (this.currentVersion >= 730) {
        openNewWindow(document.title, this.currentVersion)
      } else {
        this.$alert(`抱歉！您当前版本(v${(window.klb_req && window.klb_req.ver) || 0})不支持在软件内打开新用户，
        请先升级到7.3.0及以上版本，<span id='updateSoft' style='color:#428BCB; font-size: 17px;margin-right:5px; cursor:pointer;'
        onclick="layer.open({content:(${this.currentVersion >= 629 ? '正在更新...' : '正在下载...'}),type:2});
        setTimeout(function(){layer.closeAll()},4000);(${this.currentVersion >= 629 && window.IAgencyWebCall ? window.IAgencyWebCall('ExeFile', 0, 'updater.exe', '', 0) : openNavUrl('/', '', 'http://pro.youbaolian.cn', 'blank', false, 2)});"
        title='点我立即升级'>点我立即升级</span>`, '', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '关闭'
        })
      }
    },
    connectSpecialNetWork () {
      let _this = this
      /* let localKey = 'laterCheckTime'
      let item = localStorage.getItem(localKey)
      let json = (item && JSON.parse(item)) || ''
      let minute = (json && json.time && (day.now().unix() - day.now(json.time)) / 60) || 100
      if (_this.currentMessage.icon === 'el-icon-success' && minute < 30) { // 判断链接状态且未超时30分钟 不做处理
        return
      } */
      if (_this.currentVersion > _this.softVersion.killProcess) {
        _this.killProcess()
      }
      _this.changeNetwork().then(data => {
        _this.reload760ProxyPlugin()
        setTimeout(() => {
          _this.checkProxy(data.testUrl, this.userInfo.PartnerId, _this.callBackFun)
        }, 2000)
        setTimeout(() => {
          _this.killProcess(false)
        }, 4000)
      }).then(() => {
        _this.currentMessage = _this.messages[1]
      })
    },
    /** 重启软件7.6版本 代理插件 */
    reload760ProxyPlugin () {
      if (this.currentVersion < 760) {
        return
      }
      let pwd = Math.random().toString().replace('.', '') + Math.random().toString().replace('.', '')
      let data = { code: this.userInfo.PartnerId, pwd: pwd }
      let action = 'ConfigGetConfig'
      return this.$store.dispatch(action, data).then(data => {
        let encodedPwd = window.IAgencyWebCall('Sign', pwd).substring(0, 32)
        if (typeof (data) === 'string') {
          data = crypto.Decrypt(data, encodedPwd)
          data = JSON.parse(data)
        }
        var applicationss = [
          'SunAgent.exe;',
          'AHIC_sunapp.exe;'
        ]
        let configText = data.Data.XmlText.replace(/(<Applications>)(.*)(<\/Applications>)/igm, '$1' + applicationss.join('') + '$3')

        window.external.IAgencyWebCall('SaveFile', 0, '/pro/Profiles/yblold.ppx', configText)
        setTimeout(function () {
          var StartProxyOldLog = window.IAgencyWebCall('ExeFile', 0, '优保联.exe', ' StartProxy ', 0)
          console.log('StartProxyOld:' + StartProxyOldLog)
        }, 500)
      })
    },
    changeNetwork () {
      let pwd = Math.random().toString().replace('.', '') + Math.random().toString().replace('.', '')
      let data = { code: this.userInfo.PartnerId, pwd: pwd, version: this.currentVersion }
      let action = 'ConfigGetConfig'
      if ((this.currentVersion >= 730 && this.currentVersion < 2000) || this.currentVersion >= 3000) {
        action = 'configGetProxyConfig'
      }
      return this.$store.dispatch(action, data).then(data => {
        let result = {}
        if (this.currentVersion < 730 || (this.currentVersion >= 2000 && this.currentVersion < 3000)) {
          let encodedPwd = window.IAgencyWebCall('Sign', pwd).substring(0, 32)
          if (typeof (data) === 'string') {
            data = crypto.Decrypt(data, encodedPwd)
            data = JSON.parse(data)
          }
          result.testUrl = data.Data.TestUrl
          result.configText = data.Data.XmlText
        } else {
          result.configText = data.ProxyConfigText
          result.testUrl = data.TestUrl
        }
        if (this.currentVersion >= 3000) {
          window.IAgencyWebCall('StartYblProxy', result.configText)
        } else {
          window.IAgencyWebCall('StartProxy', result.configText)
        }
        // window.IAgencyWebCall('StartProxy', result.configText)
        return result
      })
    },
    checkProxy (testUrl, pid, fn) {
      if (testUrl) {
        testUrl = testUrl.split('$')
        if (testUrl.length) {
          this.getRequest(testUrl[0]).then(() => {
            fn(true, pid)
          }).catch(() => {
            fn(false, pid)
          })
        } else {
          fn(false, pid)
        }
      }
    },
    callBackFun (rt, proxyId) {
      let messages = [{ message: '切换出单系统网失败，请确认服务可用~', type: 'error' }, { message: '恭喜你，切换出单系统网成功~', type: 'success' }]
      this.$message({
        message: messages[+rt].message,
        type: messages[+rt].type
      })

      var str = JSON.stringify({ time: day.format(new Date(), 'YYYY-MM-DD HH:mm:ss'), status: rt, agencyId: 0 })
      localStorage.setItem('laterCheckTime', str)

      this.changeNetworkLog(rt, proxyId)
    },
    // 切换日志
    changeNetworkLog (rt, proxyId) {
      let params = {
        Pid: this.userInfo.PartnerId,
        Cid: this.userInfo.CustomerId,
        SoftwareId: (window.klb_req && window.klb_req.clientId) || '',
        ClientIp: '',
        Version: (window.klb_req && window.klb_req.ver) || 0,
        InsurerId: '',
        ProxyId: proxyId,
        Result: rt,
        lineResult: rt
      }
      return this.$store.dispatch('LogExchangeLog', params)
    },
    getRequest (url, method = 'get') {
      return request.base(null, { url: url, method: method }).then(data => {
        return data
      })
    },
    checkCurrentNetwork (url) {
      return this.checkProxy(url, this.partnerId, this.initCallBackFun)
    },
    initCallBackFun (rt, proxyId) {
      var str = JSON.stringify({ time: day.format(new Date(), 'YYYY-MM-DD HH:mm:ss'), status: rt, agencyId: 0 })
      localStorage.setItem('laterCheckTime', str)
      let params = {
        Pid: this.userInfo.PartnerId,
        Cid: this.userInfo.CustomerId,
        SoftwareId: (window.klb_req && window.klb_req.clientId) || '',
        ClientIp: '',
        Version: (window.klb_req && window.klb_req.ver) || 0,
        InsurerId: '',
        ProxyId: proxyId,
        Result: true,
        lineResult: rt
      }
      return this.$store.dispatch('LogCheckOnLine', params)
    },
    initNetwork () {
      let localKey = 'laterCheckTime'
      let item = localStorage.getItem(localKey)
      let json = (item && JSON.parse(item)) || ''
      let testUrl = 'http://10.1.3.163:7001/pcis/core/main.jsp'
      let minute = (json && json.time && (day.now().unix() - day.now(json.time)) / 60) || 100
      if (!item || !json || !json.time || minute > 30) {
        this.currentMessage = this.messages[2]
        this.checkCurrentNetwork(testUrl)
      } else {
        this.currentMessage = this.messages[1]
      }

      /* if (minute > 30) {
        // 30分钟内不去重新检测
        this.checkCurrentNetwork(testUrl)
      } */
    },
    lockScreen () {
      this.goToOuter(`/Home/Lockscreen?l=${this.userInfo.LoginName}&r=${this.userInfo.RealName}`)
    },
    goToOuter (url) {
      openNavUrl(url, '', location.host, 'self')
    },
    openRepairedTool () {
      const loading = this.$loading({
        lock: true,
        text: '正在打开修复工具，请稍等 ...'
        // spinner: 'el-icon-loading'
        // background: 'rgba(0, 0, 0, 0.7)'
      })
      window.IAgencyWebCall('ExeFile', 0, '优保联.exe', 'IETools', 0)
      setTimeout(() => {
        loading.close()
      }, 2000)
    },
    openTool () {
      this.isShowTool = true
    },
    close () {
      this.dealText = ''
      this.unDealText = ''
      this.isShowTool = false
    },
    copyValue () {
      let txt = this.dealText.replace(/\s+/g, '')
      copy(txt)
      this.$message.success('已复制到剪贴板')
    },
    translateOpt () {
      let unDealText = this.unDealText
      console.log('unDealText', unDealText)
      if (unDealText) {
        this.dealText = unDealText.replace(/\u0020+/g, '').split('\n').filter(c => { return !!c }).join(',\n')
      } else {
        this.dealText = ''
      }
    }
  }
}
</script>

<style lang="less">
@import "../assets/less/color.less";
.layout__bottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 1px solid @border-color;
  z-index: 1000;
  background-color: @white-color;
  padding: 5px;
  cursor: pointer;
  .iconfont {
    & + .iconfont {
      margin-left: 15px;
    }
    &.focusing {
      outline: none;
    }
  }
  &__text {
    font-size: 13px;
  }
  .success {
    color: green;
  }
  .fail {
    color: red;
  }
}
.deal-container {
  width: 100%;
  margin-top: 20px;
  font-size: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .deal-item {
    width: calc((100% - 100px) / 2);
    display: inline-block;
    position: relative;
    .el-textarea__inner {
      resize: none;
    }
    .copy-icon {
      position: absolute;
      bottom: 5px;
      font-size: 16px;
      right: 5px;
      color: #999;
      z-index: 10;
    }
  }
  .deal-translate {
    display: inline-block;
    width: 100px;
    font-size: 14px;
    color: #666;
    text-align: center;
    .arrow-right {
      font-size: 18px;
      font-weight: 500;
      margin-top: 5px;
      color: @color;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue